import {APISettings} from '../config.js';

export default {
  get(api_key) {
    return fetch(APISettings.baseURL + '/leads/widget?config=1&api_key=' + api_key, {
      method: 'GET',
      headers: APISettings.headers
    })
      .then(function (response) {
        if (response.status !== 200) {
          throw response.status;
        } else {
          return response.json();
        }
      })
  },
  post(api_key, data) {
    APISettings.headers.set('Content-header', 'application/json')
    return fetch(APISettings.baseURL + '/leads/widget?api_key=' + api_key, {
      method: 'POST',
      headers: APISettings.headers,
      body: data,
    })
      .then(function (response) {
        if (response.status !== 200) {
          throw response.status;
        } else {
          return response.json();
        }
      })
  },
}
